'use client';
import { createContext } from '../../utils/create-context.js';

const [MenuItemPropsProvider, useMenuItemPropsContext] = createContext({
  name: "MenuItemPropsContext",
  hookName: "useMenuItemPropsContext",
  providerName: "<MenuItemPropsProvider />"
});

export { MenuItemPropsProvider, useMenuItemPropsContext };
